import { ThreeBody } from '@uiball/loaders';
import './loader.scss';

export const Loader = ({ message, children }) => {
	const text = message;
	return (
		<div className="loader">
			<ThreeBody
				size={35}
				speed={1.1}
				color="black"
			/>
			{text && (
				<p className="loader-text">
					{text}
				</p>
			)}
		</div>
	);
}